import React, { useEffect } from 'react'
import { ENV_URL } from '../../app/constants'

/**
 * @return {null}
 */
export default function SocialNetworksFetch(props) {
    const { setSocialNetworks } = (props = props)

    const fetchData = async () => {
        let url = `${ENV_URL}/api/V1/socialNetworks/index`
        const api = await fetch(url)
        if (api.status === 200) {
            const dataApi = await api.json()
            setSocialNetworks(dataApi)
            return true
        } else {
            return false
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return null
}
